import HttpCliente from "../HttpCliente";

export const getNotificaciones = (token) => {
  return new Promise((resolve, reject) => {
    HttpCliente.get("/Notificaciones", {
      headers: {
        "Authorization": `Bearer ${token}`,
        'accept': 'application/json'
      }
    }).then(response => {
      resolve(response.data);
    }).catch(error => {
      reject(error);
    });
  });
};

export const marcarNotificacionLeida = (token, id) => {
  return new Promise((resolve, reject) => {
    HttpCliente.put(`/Notificaciones/${id}/marcarLeida`, null, {
      headers: {
        "Authorization": `Bearer ${token}`,
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      }
    }).then(response => {
      resolve(response.data);
    }).catch(error => {
      reject(error);
    });
  });
};

export const marcarTodasLeidas = (token) => {
  return new Promise((resolve, reject) => {
    HttpCliente.put("/Notificaciones/marcarTodasLeidas", null, {
      headers: {
        "Authorization": `Bearer ${token}`,
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      }
    }).then(response => {
      resolve(response.data);
    }).catch(error => {
      reject(error);
    });
  });
};

export const eliminarNotificacion = (token, id) => {
  return new Promise((resolve, reject) => {
    HttpCliente.delete(`/Notificaciones/${id}`, {
      headers: {
        "Authorization": `Bearer ${token}`,
        'Accept': 'application/json',
      }
    }).then(response => {
      resolve(response.data);
    }).catch(error => {
      reject(error);
    });
  });
};